'use client';

import { Component, type ReactNode } from 'react';

interface LandingSectionBoundaryProps {
  children: ReactNode;
}

interface LandingSectionBoundaryState {
  failed: boolean;
}

// A CMS or database failure inside one streamed section should leave the
// rest of the landing page up. The nearest route error boundary would
// otherwise replace the whole page.
class LandingSectionBoundary extends Component<
  LandingSectionBoundaryProps,
  LandingSectionBoundaryState
> {
  state: LandingSectionBoundaryState = { failed: false };

  static getDerivedStateFromError(): LandingSectionBoundaryState {
    return { failed: true };
  }

  render() {
    if (this.state.failed) return null;
    return this.props.children;
  }
}

export default LandingSectionBoundary;
